module.exports = "images/internaat.jpg";